import React from 'react';
import { DeleteForeverOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';
import { BusinessError } from '../../../../../../../common/business-error';
import locales from '../../locales';
import { DialogActionButtons, DialogDescription } from '../../../../../../../common/dialog';
import { InvitedUserItem } from '../../interfaces';
import DetailsList from '../../../../../../../common/details-list';
import Divider from '../../../../../../../common/divider/divider';
import { formatDateToClientFormat } from '../../../../../../../../constants/helpers/dates';

interface Props {
  item: InvitedUserItem;
  handleCloseDialog: () => void;
  handleSubmitAction: (invitationId: string) => void;
  loading: boolean;
  error?: BusinessError | null;
}

const DeleteUserInvitation = ({ item, handleCloseDialog, handleSubmitAction, loading, error }: Props) => {
  const items = [
    { label: locales.deleteModal.labels.email, value: item.emailAddress },
    { label: locales.deleteModal.labels.invitationStatus, value: item.invitationStatus },
    {
      label: locales.deleteModal.labels.invitationDate,
      value: formatDateToClientFormat({ date: item.invitationDate, type: 'exclusive' })
    },
    {
      label: locales.deleteModal.labels.expirationDate,
      value: formatDateToClientFormat({ date: item.expirationDate, type: 'exclusive' })
    }
  ];
  const actions = {
    primary: {
      type: 'button' as const,
      handler: () => handleSubmitAction(item.invitationId),
      text: locales.deleteModal.button.title.delete
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseDialog,
      text: locales.deleteModal.button.title.close
    }
  };

  return (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={DeleteForeverOutlined}>
        <DetailsList numberOfColumns={2} items={items} />
        <Divider />
        You want to delete the invitation. The invited user will not be able to register a sub-account. Click{' '}
        <b>Delete</b> to confirm.
      </DialogDescription>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} danger={true} />
    </Box>
  );
};

export default DeleteUserInvitation;
